import styled from 'styled-components';
import { LinkButton, ChildrenWrapper } from '../../../../../CommonComponents/Button';

export const Button = styled(LinkButton)`
  font-family: 'Inter', sans-serif;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  height: 70px;
  width: 100%;
  padding: 0 18px;
  text-align: left;
  margin-bottom: 16px;
  display: flex;
  align-items: center;

  ${ChildrenWrapper} {
    width: 100%;
    display: flex;
    align-items: center;
    height: 100%;
  }
`;

export const ButtonTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 16px;
`;

export const ButtonTitle = styled.p`
  color: #383c42;
  font-weight: 500;
  font-size: 14px;
  margin: 0 !important;
  font-family: 'Inter', serif;
`;

export const ButtonLegend = styled.p`
  font-weight: normal;
  font-size: 12px;
  color: #6c727f;
  margin: 0 !important;
`;

export const ButtonImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  box-sizing: border-box;
  border-radius: 4px;
`;
